import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import TabMenu from "../TabMenu";
import Spacing from "../Spacing";
import OverViewSection from "../Section/OverViewSection";
import OverViewSection2 from "../Section/OverViewSection2";
import GapsInCare from "../Section/GapsInCare";
// import Performance from "../Section/Performance";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { getPractice, can_visit, setSecureData, getSecureData, getSpeciality, removeSecureItem, formatDate } from "../../helpers";
import {
  getGraphDataStatus,
  getGapsInCareStatus,
  getEncounterCount,
  getEncounterCountMonthWise,
  getEncounterAmountPaidAverage,
  getEncounterAmountPaidMonthWise,
  getChargesSubmitted,
  // getDashboardAppointments,
} from "../../services/dashboard";
// import AppointmentOverViewSection from "../Section/AppointmentOverViewSection";
import DateTimeDisplay from "../Section/DateTimeDisplay";
import { fetchFUPatients } from "../../services/labFollowUp";
import FidelisCareMeasures from "../Section/FidelisCareMeasures";
import FidelisMessageSection from "../Section/FidelisMessageSection";
import ChartCard from "../Card/ChartCard";
import { fetchFidelisPatientMessageSummery } from "../../services/fidelisPatient";
// import ReferralOverView from "../Section/ReferralOverView";
// import ChatComponent from "../../ChatComponent";

// const tabMenuData = [
//   "7 days",
//   "14 days",
//   "1 month",
//   "3 months",
//   "6 months",
//   "12 months",
// ];
export default function Dashboard({  
  selectedPracticeChange,
  fetchChangePracticeData,
  setFetchChangePracticeData,
  changePracticeSpeciality,
}) {
  const navigate = useNavigate();
  const dayOfYear = Math.floor(
    (new Date() - new Date(new Date().getFullYear(), 0, 1)) / (1000 * 60 * 60 * 24)
  );

  const [labFUMisiingData, setLabFUMisiingData] = useState(0);
  const [dashboardOverviewDataCounts, setDashboardOverviewDataCounts] =
    useState({
      high_risk_count: 0,
      preventative_due_count: 0,
      havent_visited: 0,
    });

  const [gapsInCareData, setGapsInCareData] = useState([]);
  const [patientEncounterCountMonthWise, setPatientEncounterCountMonthWise] = useState([]);
  const [encounterAmountPaidMonthWise, setEncounterAmountPaidMonthWise] = useState([]);
  const [patientEncounterCount, setPatientEncounterCount] = useState(0);
  const [patientEncounterChargeSubmitted, setPatientEncounterChargeSubmitted] = useState(0);
  const [encounterAmountPaidAverage, setEncounterAmountPaidAverage] = useState(0);
  const [dashboardLabFULoader, setDashboardLabFULoader] = useState(false);
  const [dashboardGraphLoader, setDashboardGraphLoader] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [messageData, setMessageData] = useState({});
  const [messageDataLoading, setMessageDataLoading] = useState(true);

  // const [dashboardAppointmentsCounts, setDashboardAppointmentsCounts] =
  // useState({
  //   confirmed: 0,
  //   pending: 0,
  //   reschedule: 0,
  //   expired: 0,
  //   cancelled: 0,
  // });

  var location_id = getPractice("location_id");
  var account_id = getPractice("account_id");
  var account_name = getPractice("account_name");
  let specility_id = getSpeciality()?.id || 32;
  if (selectedPracticeChange != null && fetchChangePracticeData) {
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
    account_name = selectedPracticeChange?.account_name;
    specility_id = selectedPracticeChange?.specialities[0]?.id || 32;
  }
  if (changePracticeSpeciality != null) {
    specility_id = changePracticeSpeciality?.id || 32;
  }

  const [filter, setFilter] = useState({
    account_id: account_id,
    location_id: location_id,
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    const checkRedirect = async () => {
      const justLoggedIn = await getSecureData("_just_logged_in");

      if (justLoggedIn && can_visit('ehr_veradigm')) {
        await setSecureData("_just_logged_in", false); // reset flag
        navigate("/waiting-room", { replace: true });
      }
    };

    checkRedirect();
  }, [account_name, navigate]);

  const twoDecimals = (number) => {
    try {
      return Math.floor(number * 100) / 100;
    } catch (error) {
      return 0;
    }
  };

  const getPatientEncounterCount = async () => {    
    if (can_visit("dashboard_chart_claim_submitted")) {
      try {
        const response = await getEncounterCount({
          location_id: getPractice("location_id"),
          account_id: getPractice("account_id"),
        });

        if (response) {
          setPatientEncounterCount(response?.data);
          await setSecureData("patient_encounter_count", response?.data);
          await setSecureData("dashboard_fetched_practice_location", location_id);
        }
      } catch (error) {
        // console.log("🚀 ~ getPatientEncounterCount ~ error:", error);
      }
    }
  };

  const getPatientEncounterChargeSubmitted = async () => {
    if (can_visit("dashboard_chart_payment_received")) {
      try {
        const response = await getChargesSubmitted({
          location_id: location_id,
          account_id: account_id,
        });

        if (response) {
          setPatientEncounterChargeSubmitted(twoDecimals(response?.data));
          await setSecureData("patient_charge_submittion", twoDecimals(response?.data));
          await setSecureData("dashboard_fetched_practice_location", location_id);
        }
      } catch (error) {
        // console.log("🚀 ~ getPatientEncounterChargeSubmitted ~ error:", error);
      }
    }
  };

  const getEncounterAmountPaidCountAverage = async () => {
    if (can_visit("dashboard_chart_payment_received")) {
      try {
        const response = await getEncounterAmountPaidAverage({
          location_id: location_id,
          account_id: account_id,
          days: dayOfYear,
        });

        if (response) {
          setEncounterAmountPaidAverage(twoDecimals(response?.data));
          await setSecureData(
            "patient_encounter_paid_average",
            twoDecimals(response?.data)
          );
          await setSecureData(
            "dashboard_fetched_practice_location",
            location_id
          );
        }
      } catch (error) {
        // console.log("🚀 ~ getEncounterAmountPaidAverage ~ error:", error);
      }
    }
  };

  const getEncounterAmountPaidCountMonthWise = async () => {
    if (can_visit("dashboard_chart_payment_received")) {
      try {
        const response = await getEncounterAmountPaidMonthWise({
          location_id: location_id,
          account_id: account_id,
        });

        if (response) {
          const originalData = response?.data;
          const responseData = originalData.reverse();
          setEncounterAmountPaidMonthWise(responseData);
          await setSecureData(
            "patient_encounter_month_paid",
            JSON.stringify(responseData)
          );
          await setSecureData(
            "dashboard_fetched_practice_location",
            location_id
          );
        }
      } catch (error) {
        // console.log(
        //   "🚀 ~ getEncounterAmountPaidCountMonthWise ~ error:",
        //   error
        // );
      }
    }
  };

  const getPatientEncounterCountMonthWise = async () => {
    if (can_visit("dashboard_chart_claim_submitted")) {
      try {
        const response = await getEncounterCountMonthWise({
          location_id: location_id,
          account_id: account_id,
        });

        if (response) {
          const originalData = response?.data;
          const responseData = originalData.reverse();
          setPatientEncounterCountMonthWise(responseData);
          await setSecureData(
            "patient_month_wise_encounter",
            JSON.stringify(responseData)
          );
          await setSecureData(
            "dashboard_fetched_practice_location",
            location_id
          );
        }
      } catch (error) {
        // console.log("🚀 ~ getPatientEncounterCountMonthWise ~ error:", error);
      }
    }
  };

  const getDashboardOverviewDataCounts = async () => {
    try {
      const response = await getGraphDataStatus({
        location_id: location_id,
        account_id: account_id,
      });

      if (response) {
        setDashboardOverviewDataCounts(response?.data);
        await setSecureData(
          "patient_graph_data_status",
          JSON.stringify(response?.data)
        );
        await setSecureData("dashboard_fetched_practice_location", location_id);
        setDashboardGraphLoader(false);
      }
    } catch (error) {
      // console.log("🚀 ~ getDashboardOverviewDataCounts ~ error:", error);
    }
  };

  const getDashboardOverviewLavFUData = async () => {
    try {
      const response = await fetchFUPatients({
        location_id: location_id,
        account_id: account_id,
        page: 1,
        per_page: 10000,
      });

      if (response) {
        setLabFUMisiingData(response?.data?.count);
        await setSecureData("patient_lab_fu_status", response.data.count);
        await setSecureData("dashboard_fetched_practice_location", location_id);
        setDashboardLabFULoader(false);
      }
    } catch (error) {
      // console.log("🚀 ~ fetchFUPatients ~ error:", error);
    }
  };

  // const getDashboardTodayAppointments = async () => {
  //   try {
  //     const response = await getDashboardAppointments({
  //       location_id: location_id,
  //       account_id: account_id,
  //     });

  //     setDashboardAppointmentsCounts(response.data);
  //   } catch (error) {
  //     console.log("🚀 ~ getDashboardAppointmentsCounts ~ error:", error);
  //   }
  // };

  const getGapsInCareData = async () => {
    if (can_visit("dashboard_caregaps")) {
      try {
        const response = await getGapsInCareStatus({
          location_id: location_id,
          account_id: account_id,
        });

        if (response) {
          setGapsInCareData(response?.data);
          await setSecureData(
            "patient_care_gaps",
            JSON.stringify(response?.data)
          );
          await setSecureData(
            "dashboard_fetched_practice_location",
            location_id
          );
        }
      } catch (error) {
        // console.log("🚀 ~ getGapsInCareData ~ error:", error);
      }
    }
  };

  useEffect(() => {
    const fetchPatientDashboardOverviewStatus = async () => {
      try {
        const _patient_graph_data_status = await getSecureData(
          "patient_graph_data_status"
        );
        const _dashboard_fetched_practice_location = await getSecureData(
          "dashboard_fetched_practice_location"
        );

        if (
          !_patient_graph_data_status ||
          _dashboard_fetched_practice_location !== location_id
        ) {
          getDashboardOverviewDataCounts();
          setDashboardGraphLoader(true);
        } else {
          setDashboardOverviewDataCounts(_patient_graph_data_status);
        }

        const _patient_lab_fu_status = await getSecureData(
          "patient_lab_fu_status"
        );
        if (
          !_patient_lab_fu_status ||
          _dashboard_fetched_practice_location !== location_id
        ) {
          getDashboardOverviewLavFUData();
          setDashboardLabFULoader(true);
        } else {
          setLabFUMisiingData(_patient_lab_fu_status);
        }
      } catch (error) {
        console.error("Failed to fetch patient graph data status:", error);
      }
    };
    fetchPatientDashboardOverviewStatus();

    const fetchPatientEncounterCount = async () => {
      const _patient_encounter_count = await getSecureData(
        "patient_encounter_count"
      );
      const _dashboard_fetched_practice_location = await getSecureData(
        "dashboard_fetched_practice_location"
      );
      if (
        !_patient_encounter_count ||
        _dashboard_fetched_practice_location !== location_id
      ) {
        await getPatientEncounterCount();
        // setTimeout(fetchPatientEncounterCount, 4000); // Retry every 4 seconds
      } else {
        setPatientEncounterCount(_patient_encounter_count);
      }
    };

    const fetchPatientDashboardAveragePayment = async () => {
      try {
        const _patient_encounter_paid_average = await getSecureData(
          "patient_encounter_paid_average"
        );
        const _dashboard_fetched_practice_location = await getSecureData(
          "dashboard_fetched_practice_location"
        );
        if (
          !_patient_encounter_paid_average ||
          _dashboard_fetched_practice_location !== location_id
        ) {
          getEncounterAmountPaidCountAverage();
        } else {
          setEncounterAmountPaidAverage(_patient_encounter_paid_average);
        }
      } catch (error) {
        console.error(
          "Failed to fetch patient average payment data status:",
          error
        );
      }
    };
    fetchPatientDashboardAveragePayment();

    const fetchPatientEncounterChargeSubmitted = async () => {
      const _patient_charge_submittion = await getSecureData(
        "patient_charge_submittion"
      );
      const _dashboard_fetched_practice_location = await getSecureData(
        "dashboard_fetched_practice_location"
      );
      if (
        (!_patient_charge_submittion ||
          _dashboard_fetched_practice_location !== location_id) &&
        _patient_charge_submittion !== 0
      ) {
        await getPatientEncounterChargeSubmitted();
        // setTimeout(fetchPatientEncounterChargeSubmitted, 5000); // Retry every 5 seconds
      } else {
        setPatientEncounterChargeSubmitted(_patient_charge_submittion);
      }
    };

    const fetchGapsInCareData = async () => {
      const _patient_care_gaps = await getSecureData("patient_care_gaps");
      const _dashboard_fetched_practice_location = await getSecureData(
        "dashboard_fetched_practice_location"
      );
      if (
        !_patient_care_gaps ||
        _dashboard_fetched_practice_location !== location_id
      ) {
        await getGapsInCareData();
        // setTimeout(fetchGapsInCareData, 6000); // Retry every 6 seconds
      } else {
        setGapsInCareData(_patient_care_gaps);
      }
    };

    const fetchEncounterAmountPaidCountMonthWise = async () => {
      const _patient_encounter_month_paid = await getSecureData(
        "patient_encounter_month_paid"
      );
      const _dashboard_fetched_practice_location = await getSecureData(
        "dashboard_fetched_practice_location"
      );
      if (
        !_patient_encounter_month_paid ||
        _dashboard_fetched_practice_location !== location_id
      ) {
        await getEncounterAmountPaidCountMonthWise();
        // setTimeout(fetchEncounterAmountPaidCountMonthWise, 4000); // Retry every 4 seconds
      } else {
        setEncounterAmountPaidMonthWise(_patient_encounter_month_paid);
      }
    };

    const fetchPatientEncounterCountMonthWise = async () => {
      const _patient_month_wise_encounter = await getSecureData(
        "patient_month_wise_encounter"
      );
      const _dashboard_fetched_practice_location = await getSecureData(
        "dashboard_fetched_practice_location"
      );
      if (
        !_patient_month_wise_encounter ||
        _dashboard_fetched_practice_location !== location_id
      ) {
        await getPatientEncounterCountMonthWise();
        // setTimeout(fetchPatientEncounterCountMonthWise, 5000); // Retry every 5 seconds
      } else {
        setPatientEncounterCountMonthWise(_patient_month_wise_encounter);
      }
    };

    fetchPatientEncounterCount();
    fetchPatientEncounterChargeSubmitted();
    fetchEncounterAmountPaidCountMonthWise();
    fetchPatientEncounterCountMonthWise();
    fetchGapsInCareData();
    // getDashboardTodayAppointments();
    const interval = setInterval(() => {
      if (!account_id) {
        clearInterval(interval);
        // window.location.reload();
      }
    }, 500);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedPracticeChange != null && fetchChangePracticeData) {
        setDashboardLabFULoader(true);
        setDashboardGraphLoader(true);
        setPatientEncounterCount(0);
        setEncounterAmountPaidAverage(0);
        setPatientEncounterChargeSubmitted(0);
        setPatientEncounterCountMonthWise([]);
        setEncounterAmountPaidMonthWise([]);
        setGapsInCareData([]);
        await getDashboardOverviewDataCounts();
        await getDashboardOverviewLavFUData();
        await getPatientEncounterCount();
        await getPatientEncounterCountMonthWise();
        await getEncounterAmountPaidCountAverage();
        await getPatientEncounterChargeSubmitted();
        await getEncounterAmountPaidCountMonthWise();
        await getGapsInCareData();
        // getDashboardTodayAppointments();
        setFetchChangePracticeData(!fetchChangePracticeData);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedPracticeChange,
    fetchChangePracticeData,
    setFetchChangePracticeData,
  ]);

  useEffect(() => {
    const handleRedirect = async () => {
      let redirect_url = await getSecureData("redirect");
      if (redirect_url) {         
        navigate(redirect_url);
        await removeSecureItem("redirect");
      }       
    };
    handleRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getFidelisPatientMessageSummery(filter);
  }, [filter]);

  useEffect(() => {
    setFilter({ 
      ...filter, 
      account_id: account_id,
      location_id: location_id
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id, location_id]);

  const handleDateChange = (update) => {
    const [start, end] = update;

    if (start && end && formatDate(start) === formatDate(end)) {
      setFilter({
        ...filter,
        start_date: formatDate(start),
        end_date: formatDate(start),
      });
    } else if (start && end) {
      setFilter({
        ...filter,
        start_date: formatDate(start),
        end_date: formatDate(end),
      });
    } else if (start) {
      setFilter({
        ...filter,
        start_date: formatDate(start),
        end_date: formatDate(start),
      });
    }

    setDateRange([start, end]);
  };

  const getFidelisPatientMessageSummery = async (Filter) => {
    setMessageDataLoading(true);
    try {
      if (can_visit("fidelis_care")){
        const response = await fetchFidelisPatientMessageSummery(Filter);
        if (response) {
          if (!response?.detail) {
            if(response?.data?.status === 'success'){
              setMessageData(response?.data);
            }
          }
        }
      }
    } catch (error) {
      // console.log(error);
    } finally {
      setMessageDataLoading(false);
    }
  };

  useDocumentTitle("Dashboard");

  return (
    <>      
      <div
        className="flex items-center justify-between"
        style={{ justifyContent: "space-between", gap: "15px 20px" }}
      >
        <div className="flex items-center">
          <h2 className="docpro_fs_24 docpro_mb_0 mr-2">Overview</h2>
        </div>
        <DateTimeDisplay account_id={account_id} location_id={location_id} />
      </div>
      {/* <TabMenu
        tabMenuData={tabMenuData}
        filter={true}
      /> */}
      <Spacing lg="10" sm="10" />
      <OverViewSection
        dashboardOverviewDataCounts={dashboardOverviewDataCounts}
        selectedPracticeChange={selectedPracticeChange}
        labFUMisiingData={labFUMisiingData}
        dashboardLabFULoader={dashboardLabFULoader}
        dashboardGraphLoader={dashboardGraphLoader}
      />
      <Spacing lg="10" sm="10" />
      {/* <div>
        <h2 className="docpro_fs_24 docpro_mb_0">Today</h2>
        <Spacing lg="12" sm="12" />
        <AppointmentOverViewSection 
          dashboardAppointmentsCounts={dashboardAppointmentsCounts}
        />
        <Spacing lg="20" sm="20" />
      </div> */}
      <OverViewSection2
        patientEncounterCount={patientEncounterCount}
        encounterAmountPaidMonthWise={encounterAmountPaidMonthWise}
        encounterAmountPaidAverage={encounterAmountPaidAverage}
        patientEncounterCountMonthWise={patientEncounterCountMonthWise}
        patientEncounterChargeSubmitted={patientEncounterChargeSubmitted}
      />

      {account_name === "Dr. Zaber Khan MD" && (
        <>
          <Spacing lg="20" sm="20" />
          <ChartCard>
            <FidelisMessageSection 
              filter={filter}
              setFilter={setFilter}
              dateRange={dateRange}
              setDateRange={setDateRange}
              handleDateChange={handleDateChange}
              resultDate={messageData?.result_date}
              totalMessageSent={messageData?.total_message_sent}
              totalMessageStatus={messageData?.total_message_status}
              messageDataLoading={messageDataLoading}
            />
          </ChartCard>
        </>
      )}
      {/* {can_visit('dashboard_referral')  && (
        <>
          <Spacing lg="20" sm="20" />
          <ReferralOverView
            account_id={account_id}
            location_id={location_id}
          />
        </>
      )} */}
      {can_visit("dashboard_caregaps") && (
        <>
          <Spacing lg="20" sm="20" />
          <div>
            <GapsInCare GapsInCareStatus={gapsInCareData} />
          </div>
        </>
      )}

      {account_name === "Dr. Zaber Khan MD" && (
        <>
          <Spacing lg="20" sm="20" />
          <FidelisCareMeasures />
        </>
      )}

      {/* <ChatComponent 
        account_id={account_id}
        location_id={location_id}
      /> */}
    </>
  );
}
